import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=0522f50a&scoped=true"
import script from "./teacherList.vue?vue&type=script&lang=js"
export * from "./teacherList.vue?vue&type=script&lang=js"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=0522f50a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522f50a",
  null
  
)

export default component.exports